import useSWR from 'swr'
import { authApi } from '../api'
import { authKeys } from './auth.keys'

export function usePartner() {
  const { data, error, isLoading, mutate } = useSWR(authKeys.partner, async () => {
    const result = await authApi.getMe()
    if (!result.success) return null
    return result.partner ?? null
  })

  return {
    partner: data ?? null,
    isLoading,
    error: error?.message ?? null,
    mutate,
  }
}
